import React from 'react'
import { Modal } from '@material-ui/core'
import { Button } from '@resiliatech/birdsong'
import {
  DeleteGoalContentContainer,
  FlexRowColumn,
  ModalButtonContainer,
  Header,
  Text,
} from './GoalModal.styled'

type DeleteTaskModalProps = {
  isOpen: boolean
  onClose: () => void
  onDeleteGoal: (goalId: number) => Promise<void>
  goalId: number
  isFunderSharedGoal: boolean
}

export const DeleteGoalModal = ({
  isOpen,
  onClose,
  onDeleteGoal,
  goalId,
  isFunderSharedGoal,
}: DeleteTaskModalProps) => (
  <Modal
    open={isOpen && !!goalId}
    onClose={onClose}
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
    disableEnforceFocus
  >
    <DeleteGoalContentContainer>
      <Header>Delete Goal</Header>
      <FlexRowColumn>
        {isFunderSharedGoal ? (
          <>
            <Text>
              You&apos;re sharing this goal with your funder, are you sure you
              want to delete it?
            </Text>
            <Text>
              Your funder and team members assigned to this goal will not be
              able to see it anymore, and all details and progress made will be
              deleted.
            </Text>
          </>
        ) : (
          <>
            <Text>Are you sure you want to delete this goal?</Text>
            <Text>
              Team members that are assigned to this goal will not be able to
              see it anymore, and all details and progress made will be deleted.
            </Text>
          </>
        )}
      </FlexRowColumn>
      <ModalButtonContainer>
        <Button
          label='Cancel'
          onClick={onClose}
          type='button'
          variant='tertiary'
        />
        <Button
          label='Delete'
          onClick={() => onDeleteGoal(goalId)}
          type='button'
          variant='primary'
        />
      </ModalButtonContainer>
    </DeleteGoalContentContainer>
  </Modal>
)
